module.exports = new __parcel__URL__("metropolis-pt-2-scenes-from-a-memory.89c39a8e.jpg").toString();